import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, Text, StyleSheet, ScrollView, Dimensions, RefreshControl } from 'react-native';

import Colors from '../../constants/Colors';
import VisitListDay from './VisitListDay';
import timeUtils from '../../utils/timeUtils';

const styles = StyleSheet.create({
  view: {
    backgroundColor: Colors.lightBackground,
    height: Dimensions.get('window').height - 56,
    flex: 1,
    alignItems: 'center',
  },
  header: {
    backgroundColor: Colors.white,
    borderBottomColor: Colors.grayBorder,
    borderBottomWidth: 1,
    height: 56,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  headerText: {
    color: Colors.mediumBlue,
    fontSize: 20,
    fontWeight: '500',
  },
  scrollContainer: {
    flex: 1,
    maxWidth: 720,
    width: '100%',
  },
  contentContainer: {
    paddingBottom: 56,
  },
});

class VisitList extends PureComponent {
  static propTypes = {
    translation: PropTypes.objectOf(PropTypes.any).isRequired,
    locale: PropTypes.string.isRequired,
    visits: PropTypes.array.isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any),
    registration: PropTypes.objectOf(PropTypes.any),
  };

  constructor(props) {
    super();
    this.state = {
      refreshing: false,
    };
  }

  onRefresh = () => {
    const { actions } = this.props;
    this.setState({ refreshing: true });
    actions.getVisits(() => {
      this.setState({ refreshing: false });
    });
  };

  capitalize = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  render() {
    const { translation, visits, locale, actions, navigation, registration } = this.props;
    const { refreshing } = this.state;
    const labels = {
      visits: translation.fragment_main_bottombar_visits,
    };

    const dayVisits = {};
    const days = [];
    if (visits && visits.length) {
      visits
        .sort((a, b) => (a.date > b.date ? -1 : 1))
        .map((visit) => {
          const serviceDate = timeUtils.getServiceDateFromUnixTimestamp(visit.date);
          if (!dayVisits[serviceDate]) dayVisits[serviceDate] = [];
          dayVisits[serviceDate].push(visit);
        });
      Object.keys(dayVisits).forEach((date, index) => {
        days.push(
          <VisitListDay
            key={`VisitListDay-${index}`}
            translation={translation}
            locale={locale}
            actions={actions}
            visits={dayVisits[date]}
            serviceDate={date}
            navigation={navigation}
            registration={registration}
          />
        );
      });
    }

    return (
      <View style={styles.view}>
        <View style={styles.header}>
          <Text style={styles.headerText}>{this.capitalize(labels.visits)}</Text>
        </View>
        {days.length ? (
          <ScrollView
            style={styles.scrollContainer}
            contentContainerStyle={styles.contentContainer}
            refreshControl={<RefreshControl refreshing={refreshing} onRefresh={this.onRefresh} />}
          >
            {days}
          </ScrollView>
        ) : null}
      </View>
    );
  }
}

export default VisitList;
